import { getFeatures } from '@/apis/features';
import { CountryCode, LiveChatConfig, LiveChatScript, LiveChatUrl, ProgramId } from '@/enums';
import { PHLiveChatScript } from '@/enums/enum/LiveChatUrl';
import { getCountryCode } from '@/helpers/CountryCodeHelper';
import { useAppDispatch, useAppSelector } from '@/hook';
import { getHost } from '@/hooks/useRouteSection';
import LiveChatImg from "@/images/live_chat.png";
import { Script } from 'gatsby';
import { useEffect, useMemo } from 'react';
import styled from 'styled-components';

const MaychatScript = ({
  url,
  config,
  index,
}: { url: string, config: LiveChatConfig, index: number }) => {
  return config === LiveChatConfig.NEW_TAB ? (
    <ChatIcon href={url} target='_blank'></ChatIcon>
  ) : (
    <Script id={`chatbox_${index}`}>
      {`
        var LHCChatOptions = {};
        LHCChatOptions.opt = {widget_height:340,widget_width:300,popup_height:520,popup_width:500};
        (function() {
          // Additional Data Values
          LHCChatOptions.attr = new Array();
          LHCChatOptions.attr.push({'name':'Channel','value':'ETIQA Web'});  
          LHCChatOptions.attr.push({'name':'Stage','value':'Pre Login'}); 

          var po = document.createElement('script'); po.type = 'text/javascript'; po.async = true;
          var referrer = (document.referrer) ? encodeURIComponent(document.referrer.substr(document.referrer.indexOf('://')+1)) : '';
          var location  = (document.location) ? encodeURIComponent(window.location.href.substring(window.location.protocol.length)) : '';
          po.src = '${url}?tenant=ETIQA&r='+referrer+'&l='+location;
          var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(po, s);
        })();
      `}
    </Script>
  );
};

const ChatboxComponent = () => {
  const host = getHost() || '';
  const isUAT = host.includes(ProgramId.UAT);

  const dispatch = useAppDispatch();

  const config = useAppSelector((state) =>
    state.uiState.features?.liveChat ?? LiveChatConfig.POP_UP
  );

  const urls = useMemo(() => ({
    [LiveChatConfig.NEW_TAB]: LiveChatUrl,
    [LiveChatConfig.POP_UP]: LiveChatScript,
  }[config]), [config])

  const phUrls = useMemo(() => ({
    [LiveChatConfig.POP_UP]: PHLiveChatScript,
  }[config]), [config])

  const arrUrl = useMemo(() =>
    isUAT ? [urls.UatExternal, urls.UatInternal] : [urls.ProdExternal]
    , [urls]);

  const arrPHUrl = useMemo(() =>
    isUAT ? [phUrls.UatExternal, phUrls.UatInternal] : [phUrls.ProdExternal]
    , [phUrls]);

  useEffect(() => {
    dispatch(getFeatures())
  }, []);

  const ChatboxMY = () => {
    return (
      <div>
        {arrUrl.map((url, index) => (
          <MaychatScript key={url} url={url} config={config} index={index} />
        ))}
      </div >
    );
  };

  const ChatboxPH = () => {
    return (
      <div>
        {arrPHUrl.map((url, index) => (
          <MaychatScript key={url} url={url} config={config} index={index} />
        ))}
      </div >
    );
  };

  const chatboxByCountry = {
    [CountryCode.Malaysia]: <ChatboxMY />,
    [CountryCode.Philippines]: <ChatboxPH />,
  };

  return chatboxByCountry[getCountryCode()];
};

const ChatIcon = styled.a`
  display: block;
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  padding: 12px;
  height: 52px;
  width: 52px;
  background-image: url(${LiveChatImg});
  background-repeat: no-repeat;
  background-position: center center;
  background-color: #FFBF00;
  border: 2px solid #e3e3e3;
  border-radius: 47px;
  border-color: #F9F9F9;
  box-shadow: 0 0 17px rgba(50, 50, 50, 0.5);
  text-decoration: none;
  font-size: 38px;
`

export default ChatboxComponent;
